let RETURN_URL= 'https://hotel.sunacctg.com/pc',
	LOGIN_URL= 'https://hotel.sunacctg.com/auth',
	IS_YH= true,
	IS_NMG= false,
	IS_RC= false

const href = window.location
switch ( href.host ) {
	case '127.0.0.1:8090':
		RETURN_URL= 'http://127.0.0.1:8090',
		LOGIN_URL='http://testcem1.mgit365.com:8020/auth',
		IS_YH = true,
		IS_NMG = false,
		IS_RC = false
		break
	case '47.95.130.146:8090':  //融创测试环境
		RETURN_URL= 'http://47.95.130.146:8090/pc',
		LOGIN_URL= 'http://47.95.130.146:8090/auth',
		IS_YH= false,
		IS_NMG= false,
		IS_RC= true
		break
	case '39.97.129.132:8080':
		RETURN_URL= 'http://39.97.129.132:8080/pc',
		LOGIN_URL= 'http://39.97.129.132:8080/auth',
		IS_YH= false,
		IS_NMG= false,
		IS_RC= true
		break
	case 'testcem1.mgit365.com':
		RETURN_URL= 'http://testcem1.mgit365.com/pc',
		LOGIN_URL= 'http://testcem1.mgit365.com/auth',
		IS_YH= false,
		IS_NMG= false,
		IS_RC= true
		break
	case 'testcem1.mgit365.com:8020':  //粤海测试环境
		RETURN_URL= 'http://testcem1.mgit365.com:8020/pc',
		LOGIN_URL= 'http://testcem1.mgit365.com:8020/auth',
		IS_YH= true,
		IS_NMG= false,
		IS_RC= false
		break
	case 'hotel.sunacctg.com':  //融创生产老地址
		RETURN_URL= 'https://hotel.sunacctg.com/pc',
		LOGIN_URL= 'https://hotel.sunacctg.com/auth',
		IS_YH= false,
		IS_NMG= false,
		IS_RC= true
		break
	case 'www.sunachotels.com.cn':  //融创生产新地址
		RETURN_URL= 'https://www.sunachotels.com.cn/pc',
		LOGIN_URL= 'https://www.sunachotels.com.cn/auth',
		IS_YH= false,
		IS_NMG= false,
		IS_RC= true
		break
	case 'booking.gdhhotels.com': //粤海生产
		RETURN_URL= 'http://booking.gdhhotels.com/pc',
		LOGIN_URL= 'http://booking.gdhhotels.com/auth',
		IS_YH= true,
		IS_NMG= false,
		IS_RC= false
		break
	case 'www.gdhhotels.com': //品宣粤海生产
		RETURN_URL= 'http://www.gdhhotels.com/pc',
		LOGIN_URL= 'http://www.gdhhotels.com/auth',
		IS_YH= true,
		IS_NMG= false,
		IS_RC= false
		break
	default:
		RETURN_URL= 'http://testcem1.mgit365.com/pc',
		LOGIN_URL= 'http://testcem1.mgit365.com/auth',
		IS_YH= false,
		IS_NMG= false,
		IS_RC= true
		break
}
export {
	RETURN_URL,
	LOGIN_URL,
	IS_YH,
	IS_NMG,
	IS_RC
}



// WEBPACK FOOTER //
// ./src/config/index.js